import { toast } from "react-toastify";
import { getBaseFuel, getRateCard } from "redux/actions/UserRateCard";
import store from "redux/store";

import { call, put, takeEvery } from "redux-saga/effects";
import { baseFuelApi, postRateCardApi, rateCardApi } from "services/RateCardService";
import { GET_ADDRATECARD_FAILED, GET_ADDRATECARD_REQUESTED, GET_ADDRATECARD_SUCCESS, GET_BASE_FUEL_FAILED, GET_BASE_FUEL_REQUESTED, GET_BASE_FUEL_SUCCESS, GET_RATECARD_FAILED, GET_RATECARD_REQUESTED, GET_RATECARD_SUCCESS } from "resources/actionTypes";
import { onLoaderTrigger } from "redux/actions/CommonAction";
function* fetchRateCard(action) {
  try {
    const payload = action.payload || {}
    const userRateCard = yield call(rateCardApi, payload);
    yield put({ type: GET_RATECARD_SUCCESS, userRateCard: userRateCard });
  } catch (e) {
    yield put({ type: GET_RATECARD_FAILED, message: e.message })
    toast.error(e.message || 'Get Rate Card Failed')
  }
}

export function* rateCardSaga() {
  yield takeEvery(GET_RATECARD_REQUESTED, fetchRateCard);
}

function* fetchAddRateCard(action){
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userAddRateCard = yield call(postRateCardApi,payload.userAddRateCard);
  if(userAddRateCard.success){
    yield put({ type: GET_ADDRATECARD_SUCCESS, userAddRateCard: userAddRateCard});
    toast.success(userAddRateCard.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getRateCard({
      carId: payload?.userAddRateCard?.carType,
      type: payload?.userAddRateCard?.type,
      baseFuelPrice:parseFloat(payload?.userAddRateCard?.baseFuelPrice),
      location:payload?.userAddRateCard?.location
    }));
    store.dispatch(getBaseFuel({location:payload?.userAddRateCard?.location}));
  }
  else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_ADDRATECARD_FAILED, message: userAddRateCard.message})
      toast.error(userAddRateCard.message || 'Add Rate Card Failed');
  }
}
export function* addRateCardSaga(){
  yield takeEvery(GET_ADDRATECARD_REQUESTED, fetchAddRateCard);
}

function* fetchBaseFuel(action) {
  try {
    const payload = action.payload || {}
    const userBaseFuel = yield call(baseFuelApi, payload);
    yield put({ type: GET_BASE_FUEL_SUCCESS, userBaseFuel: userBaseFuel });
  } catch (e) {
    yield put({ type: GET_BASE_FUEL_FAILED, message: e.message })
    toast.error(e.message || 'Get Base Fuel Failed')
  }
}

export function* baseFuelSaga() {
  yield takeEvery(GET_BASE_FUEL_REQUESTED, fetchBaseFuel);
}

